<template>
  <div class="header-ia-icone">
    <div class="header-ia-icone-title">
      <div class="header-ia-icone-title-logo">
        <F360Iconia />
      </div>
      <h3>{{ title }}</h3>
    </div>
    <MaterialIcon
      class="close"
      icon="close"
      size="20px"
      cursor="pointer"
      @click="handleClose"
    />
  </div>
</template>

<script setup lang="ts">
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import F360Iconia from "@/ui/components/Icons/ia/F360Iconia.vue";

defineProps<{
  title: string;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();

const handleClose = () => {
  emit("close");
};
</script>

<style lang="scss">
.header-ia-icone {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid _map.get($map: $neutro, $key: 100);
  padding: 16px;

  &-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.25rem;
      color: _map.get($map: $neutro, $key: 900);
    }

    &-logo {
      background-color: _map.get($map: $azulPrincipal, $key: 700);
      border-radius: 0.5rem;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: auto;
      }
    }
  }

  .close {
    cursor: pointer;
  }
}
</style>
